(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kidshq-bundle-save"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const radio = event.target.closest('[data-khq-bs] input[type="radio"]');
    if (!radio) return;
    const button = radio.closest('[data-khq-bs]').querySelector('[data-khq-bs-add]');
    button.textContent = radio.value === 'single' ? 'Add to cart' : 'Add bundle to cart';
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-khq-bs-add]');
    if (!button) return;
    const root = button.closest('[data-khq-bs]');
    const error = root.querySelector('[data-khq-bs-error]');
    const formId = document.querySelector('form[action*="/cart/add"] [name="id"]');
    const currentId = (formId && formId.value) || root.dataset.currentVariant;
    const checked = root.querySelector('input[type="radio"]:checked');
    const single = checked && checked.value === 'single';
    const items = [{ id: Number(currentId), quantity: 1 }];
    if (!single) items.push({ id: Number(root.dataset.partnerVariant), quantity: 1 });
    error.hidden = true;
    button.disabled = true;
    try {
      const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) throw new Error('add failed');
      window.location.href = base + 'cart';
    } catch (e) {
      error.textContent = single ? 'Sorry, we could not add this item. Please try again.' : 'Sorry, we could not add the bundle. Please try again.';
      error.hidden = false;
      button.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
